
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  beforeCreate() {
    console.log('componentBeforeCreate', this);
  },
  created() {
    console.log('componentCreated', this);
  },
  beforeMount() {
    console.log('componentBeforeMount', this);
  },
  mounted() {
    console.log('componentMounted', this);
    this.loadVideo();
  },
  beforeDestroy() {
    console.log('componentBeforeDestroy', this);
    var DM = this.$root.DM;
    if (this.playerExist)
      DM.destroy();
  },
  destroyed() {
    console.log('componentDestroyed', this);
  },
  data() {
    return { playerExist: false };
  },
  methods: {
    loadVideo() {
      console.log('start loadVideo() ', 'this.$root.DM:', this.$root.DM);
      if (this.$app.online) {
        this.playerExist = true;
        var DM = this.$root.DM;
        var player = DM.player(document.getElementById('videoPlayer'), {
          video: 'xwr14q',
          width: '100%',
          height: '100%',
          params: {
            autoplay: false,
            mute: false
          }
        });
      } else {
        console.log('please turn on internet');
      }
      console.log('end loadVideo() ', 'this.$root.DM:', this.$root.DM);
    }
  },
  id: '5d691d8c07',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page" data-name="about">\r\n        <div class="navbar">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner sliding">\r\n                <div class="left">\r\n                    <a href="#" class="link back">\r\n                        <i class="icon icon-back"></i>\r\n                        <span class="if-not-md">Back</span>\r\n                    </a>\r\n                </div>\r\n                <div class="title">';
      r += c(ctx_1.$route.params.title, ctx_1);
      r += '</div>\r\n            </div>\r\n        </div>\r\n        <div class="page-content">\r\n            <!--   <div class="row no-gap">\r\n                <div class="col-auto bg-color-lightblue medium-75">\r\n                    <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;"><iframe\r\n                            style="width:100%;height:100%;position:absolute;left:0px;top:0px;overflow:hidden"\r\n                            frameborder="0" type="text/html"\r\n                            src="https://dailymotion.com/embed/playlist/x692vj?autoplay=0" width="100%" height="100%"\r\n                            allow="autoplay" allowfullscreen></iframe></div>\r\n                </div>\r\n                \r\n            </div> -->\r\n\r\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.$app.online, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="block" id="videoPlayer"></div>\r\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n            <div class="block" id="videoPlayer">\r\n                <h1>Please turn on internet</h1>\r\n            </div>\r\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n            <div class="col-auto medium-25">\r\n                <div class="block-header">Lectures List</div>\r\n                <div class="list">\r\n                    <ul>\r\n                        <li>\r\n                            <a href="#" class="item-link item-content">\r\n                                <div class="item-inner">\r\n                                    <div class="item-title bg-color-white">Lecture 1</div>\r\n                                    <div class="item-after"><span class="badge color-blue">Previous</span></div>\r\n                                </div>\r\n                            </a>\r\n                        </li>\r\n                        <li class="bg-color-white text-color-green"><a href="#" class="item-link item-content">\r\n                                <div class="item-inner">\r\n                                    <div class="item-title" wappler-command="editContent">Lecture 2</div>\r\n                                    <div class="item-after"><span class="badge color-green"\r\n                                            wappler-command="editContent">Playing</span></div>\r\n                                </div>\r\n                            </a></li>\r\n                        <li>\r\n                            <a href="#" class="item-link item-content">\r\n                                <div class="item-inner">\r\n                                    <div class="item-title">Lecture 3</div>\r\n                                    <div class="item-after"><span class="badge color-blue">Next</span></div>\r\n\r\n                                </div>\r\n                            </a>\r\n                        </li>\r\n\r\n                    </ul>\r\n                </div>\r\n\r\n            </div>\r\n\r\n\r\n        </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  style: `
    #videoPlayer {
        background-color: cyan;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }
`,
  styleScoped: false
};
    